import { classNames as cn } from "tools/ui";
import { getOrderTimeStatus, getElapsedTimeLabel } from "../../functions/times";
import { ClockIcon } from "components/Icons";

function LabelTime({ time }) {
  const status = getOrderTimeStatus(time);
  const currentTime = getElapsedTimeLabel(time);
  const { label, style } = status;

  return (
    <div className="flex space-x-3 items-center">
      <div className="flex items-center space-x-2" title={label}>
        {/* <ClockIcon className="size-[17px] text-gray-500 fill-current relative -top-[1px]" /> */}
        <span className="font-bold -ml-1">{currentTime}</span>
        <div
          className={cn(
            "size-4 rounded-full shadow-md 0 border relative -top-0.5",
            style,
          )}
        />
      </div>
    </div>
  );
}

export default LabelTime;
